module.exports = __webpack_public_path__ + "img/robot.674d11b6.png";